import { useAuth } from '@/contexts/AuthContext';
import { EXPERIENCE } from '@touchworks/shared/platform/experience.js';

/**
 * Qual "casca" a conta vê (docs/specs/otto/TDD.md §5): `platform` (a plataforma de sempre) ou `otto` (a conta contratou
 * só o Otto). Vem do plano (`Plan.product`), nunca das chaves liberadas: em trial `hasFeature` vale para tudo, então
 * deduzir "só Otto" pela falta de módulos erraria. Antes do primeiro fetch, e se ele falhar, vale `platform`.
 *
 * @returns {{ experience: 'platform' | 'otto', isOtto: boolean }}
 */
export function useExperience() {
  const { experience } = useAuth();
  return { experience, isOtto: experience === EXPERIENCE.OTTO };
}
